// extracted by mini-css-extract-plugin
export default {"child1":"Settings_child1__mVZ8V","child2":"Settings_child2__QC1gj","parent":"Settings_parent__ig0rk"};